import { PartnerManagerDictionary } from 'types/i18n';
import { UnreachableError } from 'utils/errors';
import { ISOCountries } from 'utils/isoCountries';
import { normalizeProfileLike } from 'utils/profileLikeUtils';
import { datesDictionaryRu } from './datesDictionaryRu';

export const partnerManagerDictionaryRu: PartnerManagerDictionary = {
  tabs: {
    summaryTabText: 'Сводка',
    financesTabText: 'Финансы',
    clientsTabText: 'Клиенты',
  },
  summaryScreen: {
    editProfileActionText: 'Редактировать анкету',
    editCredentialsActionText: 'Редактировать логин',
    editPasswordActionText: 'Редактировать пароль',
    blockPartnerActionText: 'Заблокировать',
    unblockPartnerActionText: 'Разблокировать',
  },
  partnerInfoTable: {
    titleText: 'О партнере',

    fullNameLabel: 'ФИО',
    partnerCodeLabel: 'Код партнера',
    emailLabel: 'Email',
    phoneLabel: 'Телефон',
    clientsCountLabel: 'Клиенты',
    balanceLabel: 'Баланс',
    registrationDateLabel: 'Регистрация',
    latestUpdateDateLabel: 'Изменение',
    idLabel: 'ID',
    statusLabel: 'Статус',
    generateSecretCodeText: 'Изменить',
    detailsLabel: 'Опыт',
    locationLabel: 'Локация',

    clientsCountText(clientsCount) {
      return `${clientsCount} клиентов`;
    },
    registrationDateText(date) {
      return datesDictionaryRu.calendarDateWithTime(new Date(date));
    },
    latestUpdateDateText(date) {
      return datesDictionaryRu.calendarDateWithTime(new Date(date));
    },
    statusText(status) {
      switch (status) {
        case 'ACTIVE':
          return 'Активный';
        case 'DISABLED':
          return 'Заблокирован';
        case 'CANDIDATE':
          return 'Регистрация';
        default:
          throw new UnreachableError(status);
      }
    },
    locationText(country, city) {
      const countryName = ISOCountries.getName(country, 'ru');

      return `${countryName}, ${city}`;
    },
  },

  passwordEditorScreen: {
    titleText: 'Редактирование пароля',
    submitActionText: 'Сохранить изменения',
    cancelActionText: 'Отмена',
  },

  credentialsEditorScreen: {
    titleText: 'Редактирование логина',
    submitActionText: 'Сохранить изменения',
    cancelActionText: 'Отмена',
  },

  rewardEditorScreen: {
    titleText: 'Выплата вознаграждения',
    submitActionText: 'Сохранить изменения',
    cancelActionText: 'Отмена',
  },

  profileEditorScreen: {
    titleText: 'Редактирование анкеты',
    submitActionText: 'Сохранить изменения',
    cancelActionText: 'Отмена',
  },

  clientsScreen: {
    fallbackText: 'Нет клиентов',
    organizationLabel: 'Организация',
    contactLabel: 'Контакт',
    registrationDateLabel: 'Регистрация',
    subscriptionEnabledLabel: 'Подписка',

    contactText(client) {
      return normalizeProfileLike(client).toFullName();
    },
    subscriptionStatusText(active) {
      if (active) {
        return 'Активна';
      }

      return 'Отменена';
    },
  },
};
